import * as React from "react";
const IconCross = (props) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7291 7.74981L8.24377 16.2351M16.7291 16.235L8.24377 7.74976"
      stroke={props.color || "#db5800"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconCross;
